@if ({
  model: model$ | async,
  }; as content) {
  @if (!isInfiniteScroll) {
    <div class="cx-pagination">
      <cx-custom-pagination [pagination]="content.model?.pagination" queryParam="currentPage" [defaultPage]="0"></cx-custom-pagination>
    </div>
  }
}
